import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/grupo-acesso';

export default {
  cadastrar: async (contaspagar) => {
    return financeiroApi.post(`${PATH}`, contaspagar);
  },
  buscarPorId: async (key) => {
    return financeiroApi.get(`${PATH}/${encodeURIComponent(key)}`);
  },
  buscar: async (params) =>
    financeiroApi.get(`${PATH}`, {
      params,
    }),
  pesquisar: async (params) =>
    financeiroApi.get(`${PATH}/pesquisar`, {
      params,
    }),
  atualizar: async (id, contaspagar) => {
    return financeiroApi.put(`${PATH}/${id}`, contaspagar);
  },

  excluir: (filtro) => {
    return financeiroApi.delete(`${PATH}`, { data: filtro });
  },
};
